/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Tab_AvailableInputs */

const en_admin_invite_codes_tab_available = /** @type {(inputs: Admin_Invite_Codes_Tab_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available`)
};

/**
* | output |
* | --- |
* | "Available" |
*
* @param {Admin_Invite_Codes_Tab_AvailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_tab_available = /** @type {((inputs?: Admin_Invite_Codes_Tab_AvailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Tab_AvailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_tab_available(inputs)
});
export { admin_invite_codes_tab_available as "admin.invite_codes.tab_available" }